import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ChipInputComponent } from '../../../../shared-components/chip-input/chip-input.component';
import { CustomSnackbarService } from '../../../../services/custom-snackbar.service';
import { MatDialogRef } from '@angular/material/dialog';
import { RegisterUserList } from '../../../../models/user';
import { Roles } from '../../../../utils/enums';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../services/user.service';
import { emailValidator } from '../../../../utils/validators';
import { userRoles } from '../../../../utils/display-texts';

@Component({
  selector: 'app-invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss']
})
export class InviteUserComponent {
  userForm: FormGroup;
  roles = [Roles.ADMIN, Roles.SUPPORT];
  displayRoles = userRoles;

  @ViewChild(ChipInputComponent, { static: true }) emailInput!: ChipInputComponent;

  constructor(
    public dialogRef: MatDialogRef<InviteUserComponent>,
    private builder: FormBuilder,
    private snackBarService: CustomSnackbarService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.userForm = this.builder.group({
      roles: [[Roles.ADMIN]]
    });
  }

  createUserAndSendNotification(): void {
    const emails = this.emailInput.getValue();
    if (this.userForm.valid) {
      if(this.userForm.value.roles.length === 0){
        this.snackBarService.present(
          this.translate.instant('UserManagementComponent.noRoleSelectedError')
        );

        return;
      }

      if (!this.checkEmails(emails)) {
        this.snackBarService.present(
          this.translate.instant('InviteUserComponent.emailError')
        );

        return;
      }

      this.inviteUsers(emails);
    }
  }

  inviteUsers(emails: string[]): void {
    const data: RegisterUserList = {
      email: emails,
      roles: this.userForm.value.roles
    }
    this.userService.add(data).subscribe(() => {
      if(emails.length === 1){
        this.snackBarService.present(this.translate.instant('InviteUserComponent.sent'));
      } else if (emails.length > 1){
        this.snackBarService.present(this.translate.instant('InviteUserComponent.sentPlural'));
      }
      this.dialogRef.close();
    });
  }

  checkEmails(emails: string[]): boolean {
    return emails.every(emailValidator);
  }

  protected readonly emailValidator = emailValidator;
}
